module.exports = __webpack_public_path__ + "static/media/hind-bold.de20f90b.woff2";